import 'twin.macro'

import { AppWrapper } from 'components/UI/app-wrapper/app-wrapper'
import Header from 'components/views/header'
import Footer from 'components/views/Landing/Footer'
import NavMenuCabinet from 'components/views/nav-menu-cabinet'
import { Stepper } from 'components/views/stepper'
import React, { useMemo } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { pathnames } from 'utils/steps'

const LandingLayout = () => {
  const { pathname } = useLocation()
  const isCabinet = useMemo(
    () => pathname.split('/')[1] === pathnames['personal-cabinet'].replaceAll('/', ''),
    [pathname]
  )

  return (
    <>
      <Header />
      <div tw='mt-[3px] sm:mt-[40px] max-w-landing mx-auto pb-[48px] w-full sm:px-0 px-5'>
        {isCabinet && <NavMenuCabinet />}
        <Outlet />
      </div>
      {pathname === '/' && <Footer />}
    </>
  )
}

export default LandingLayout
